export default __webpack_public_path__ + "static/media/logo.be65bc4a.png";